// notification-container.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { NotificationService, Notification } from '../notification.service';

@Component({
  selector: 'app-notification-container',
  // ❌ QUITAR standalone: true
  // standalone: true,
  // imports: [CommonModule, NotificationItemComponent],
  templateUrl: './notificationContainer.html',
  styleUrls: ['./notificationContainer.scss']
})
export class NotificationContainerComponent implements OnInit, OnDestroy {
  notifications: Notification[] = [];
  private subscription!: Subscription;

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.subscription = this.notificationService.notifications$.subscribe(
      notifications => {
        this.notifications = notifications;
      }
    );
  }

  removeNotification(id: string): void {
    this.notificationService.remove(id);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  
}